import Immutable, { Map } from 'immutable';

export const LOAD_CLIENTS = 'LOAD_CLIENTS';
export const UNLOAD_CLIENTS = 'UNLOAD_CLIENTS';
export const UPDATE_CLIENTS = 'UPDATE_CLIENTS';


export default function ClientsReducer(state, action) {

    switch(action.type) {

        case LOAD_CLIENTS:

            if(action.loading) {
                state = state.setIn(['loading'], true);
            }

            if(action.collection) {
                state = state.setIn(['collection'], Immutable.fromJS(action.collection).groupBy(x => x.get('id')).map(x => x.first()))
            }

            if(action.lastSynced) {
                state = state.setIn(['lastSynced'], action.lastSynced);
            }

            return state;
        case UNLOAD_CLIENTS:

            return state;
        case UPDATE_CLIENTS:

            return state;
            default:

    }

    return state || Map();

}